module.exports = __webpack_public_path__ + "static/media/tissot.71d0ff3e.png";